import { makeStyles,useTheme } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme=>({
  wrapper: {
    margin: '30px 0'
  },
  title: {
    margin: '0 0 19px',
   [theme.breakpoints.down('sm')]:{
     textAlign: 'center'
   }

  },
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  input: {
    width: '100%',
    marginBottom: '20px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: '0 20px 0 20px'
    },
  }
}));
